import React from "react";

const CardModal = ({card}) => {
  return (
      <div className={`overflow-hidden relative rounded-lg group ${card.className}`}>
        <div className="hidden lg:block absolute top-0 h-full w-full group-hover:bg-gradient-to-b from-transparent to-black/50" />
        <div className="w-full h-40 md:h-64 mx-auto">
          <img src={card.image} alt="" className="h-full w-full object-cover" />
          <div className="lg:hidden group-hover:block absolute bottom-0 w-full p-2 text-xs bg-dark-denim/50 lg:bg-transparent text-white">
            <h3>{card.title}</h3>
            <span>{card.subtitle}</span>
          </div>
        </div>
      </div>
  );
};

export default CardModal;
